L.Control.SettingsControl = L.Control.extend({

    includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

    initialize: function (options) {
        L.Util.setOptions(this, options);
    },

    onAdd: function(map) {

        var plan = control.getPlan();
        var container = L.DomUtil.create('div', '', L.DomUtil.get('settings-container'));

        /* Switch from RT to P2P */
        var routeSwitchContainer = L.DomUtil.create('div', '', container);
        routeSwitchContainer.id = 'switch-to-p2p';
        var routeSwitchParagraph = L.DomUtil.create('p', '', routeSwitchContainer);
        routeSwitchParagraph.innerHTML = L.localisation.get('edit.body');
        var routeSwitchButton = L.DomUtil.create('button', 'btn btn-smaller btn-block', routeSwitchContainer);
        routeSwitchButton.innerHTML = L.localisation.get('edit.editRoute');

        L.DomEvent.on(routeSwitchButton, 'click', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().switchToP2P();
            control.route();
        }, this));

        /* Help link */
        var helpContainer = L.DomUtil.create('div', 'settings-help', container);
        helpContainer.innerHTML = '<i class="fa fa-question-circle" aria-hidden="true"></i> <a href="/about/#what-do-the-routing-preferences-do" target="_blank">'+L.localisation.get('settings.help')+'</a>';

        /* Green */
        var greenContainer = L.DomUtil.create('label', 'slider', container);
        var greenLabel = L.DomUtil.create('div', '', greenContainer);
        greenLabel.innerHTML = L.localisation.get('settings.preferGreenAreas');
        this.greenInput = L.DomUtil.create('input', '', greenContainer);
        this.greenInput.type = 'range';
        this.greenInput.min = 0;
        this.greenInput.max = 1;
        this.greenInput.step = 0.2;
        this.greenInput.id = 'green_preference';
        this.greenInput.value = plan.getGreenPreference();
        var greenText = L.DomUtil.create('span', '', greenContainer);
        greenText.htmlFor = 'green_preference';
        greenText.id = 'green_label';

        L.DomEvent.on(this.greenInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setGreenPreference(e.target.value);
            control.route();
        }, this));

        L.DomEvent.on(this.greenInput, 'input', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().updateGreenPreferenceUI();
        }, this));

        /* Hills */
        var hillsContainer = L.DomUtil.create('label', 'slider', container);
        var hillsLabel = L.DomUtil.create('div', '', greenContainer);
        hillsLabel.innerHTML = L.localisation.get('settings.hillsPreference');
        this.hillsInput = L.DomUtil.create('input', '', hillsContainer);
        this.hillsInput.type = 'range';
        this.hillsInput.min = -1;
        this.hillsInput.max = 1;
        this.hillsInput.step = 0.2;
        this.hillsInput.id = 'hill_preference';
        this.hillsInput.value = plan.getHillPreference();
        var hillsText = L.DomUtil.create('span', '', hillsContainer);
        hillsText.htmlFor = 'hill_preference';
        hillsText.id = 'hill_label';

        L.DomEvent.on(this.hillsInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setHillPreference(e.target.value);
            control.route();
        }, this));

        L.DomEvent.on(this.hillsInput, 'input', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().updateHillsPreferenceUI();
        }, this));

        /* Avoid repetition */
        var repetitionContainer = L.DomUtil.create('label', 'checkbox', container);
        this.avoidRepetitionInput = L.DomUtil.create('input', 'filled-in', repetitionContainer);
        this.avoidRepetitionInput.type = 'checkbox';
        this.avoidRepetitionInput.id = 'avoid_repetition';
        this.avoidRepetitionInput.checked = plan.getAvoidRepetition();
        var repetitionText = L.DomUtil.create('span', '', repetitionContainer);
        repetitionText.htmlFor = 'avoid_repetition';
        repetitionText.innerHTML = L.localisation.get('settings.avoidRepetition');

        L.DomEvent.on(this.avoidRepetitionInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setAvoidRepetition(e.target.checked);
            control.route();
        }, this));

        /* Avoid unsafe streets */
        var safeStreetsContainer = L.DomUtil.create('label', 'checkbox', container);
        this.avoidUnsafeStreetsInput = L.DomUtil.create('input', 'filled-in', safeStreetsContainer);
        this.avoidUnsafeStreetsInput.type = 'checkbox';
        this.avoidUnsafeStreetsInput.id = 'avoid_unsafe_streets';
        this.avoidUnsafeStreetsInput.checked = plan.getAvoidUnsafeStreets();
        var safeStreetsText = L.DomUtil.create('span', '', safeStreetsContainer);
        safeStreetsText.htmlFor = 'avoid_unsafe_streets';
        safeStreetsText.innerHTML = L.localisation.get('settings.avoidUnsafeRoads');

        L.DomEvent.on(this.avoidUnsafeStreetsInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setAvoidUnsafeStreets(e.target.checked);
            control.route();
        }, this));

        /* Avoid unlit streets */
        var litStreetsContainer = L.DomUtil.create('label', 'checkbox', container);
        this.avoidUnlitStreetsInput = L.DomUtil.create('input', 'filled-in', litStreetsContainer);
        this.avoidUnlitStreetsInput.type = 'checkbox';
        this.avoidUnlitStreetsInput.id = 'avoid_unlit_streets';
        this.avoidUnlitStreetsInput.checked = plan.getAvoidUnlitStreets();
        var litStreetsText = L.DomUtil.create('span', '', litStreetsContainer);
        litStreetsText.htmlFor = 'avoid_unlit_streets';
        litStreetsText.innerHTML = L.localisation.get('settings.avoidUnlitStreets');

        L.DomEvent.on(this.avoidUnlitStreetsInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setAvoidUnlitStreets(e.target.checked);
            control.getPlan().setGreenPreference(e.target.checked ? 0 : 0.8);
            control.getPlan().updateSettingsUI();
            control.route();

            map.removeLayer(layers.litstreets);
            if (e.target.checked) {
               layers.litstreets.addTo(map);
            }

        }, this));

        var layerParagraph = L.DomUtil.create('p', '', container);
        layerParagraph.innerHTML = L.localisation.get('settings.mapLayers');

        /* Map layers */
        this.selectLayersInput = L.DomUtil.create('select', '', container);
        this.selectLayersInput.id = 'selectLayers';
        this.selectLayersInput.options.add( new Option(L.localisation.get('settings.mapLayerTrailRouter'),"default",true,true) );
        this.selectLayersInput.options.add( new Option(L.localisation.get('settings.mapLayerDarkMap'),"dark") );
        this.selectLayersInput.options.add( new Option(L.localisation.get('settings.mapLayerLightMap'),"light") );
        this.selectLayersInput.options.add( new Option(L.localisation.get('settings.mapLayerSatellite'),"satellite") );
        this.selectLayersInput.options.add( new Option("OpenTopoMap","opentopomap") );
        this.selectLayersInput.options.add( new Option("OpenStreetMap","osm") );
        L.DomEvent.addListener(this.selectLayersInput, 'change', function() {
            control.getPlan().setBaseLayer(this.selectLayersInput.value);
            layers[this.selectLayersInput.value].addTo(map);
            if (map.baseLayer) {
               map.removeLayer(map.baseLayer);
            } else {
               map.removeLayer(layers.default);
            }
            map.baseLayer = layers[this.selectLayersInput.value];
        }, this);

        /* Hiking layer */
        var hikingLayerContainer = L.DomUtil.create('label', 'checkbox', container);
        this.hikingLayerInput = L.DomUtil.create('input', 'filled-in', hikingLayerContainer);
        this.hikingLayerInput.type = 'checkbox';
        this.hikingLayerInput.id = 'hiking_layer';
        this.hikingLayerInput.checked = plan.getHikingLayer();
        var hikingLayerText = L.DomUtil.create('span', '', hikingLayerContainer);
        hikingLayerText.htmlFor = 'hiking_layer';
        hikingLayerText.innerHTML = L.localisation.get('settings.showMajorHikingRoutes');

        L.DomEvent.on(this.hikingLayerInput, 'change', L.bind(function(e) {
            control.getPlan().setHikingLayer(e.target.checked);
            map.removeLayer(layers.hiking);
            if (e.target.checked) {
               layers.hiking.addTo(map);
            }
            L.DomEvent.preventDefault(e);
        }, this));

        /* Strava layer */
        /*
        var stravaLayerContainer = L.DomUtil.create('label', 'checkbox', container);
        this.stravaLayerInput = L.DomUtil.create('input', 'filled-in', stravaLayerContainer);
        this.stravaLayerInput.type = 'checkbox';
        this.stravaLayerInput.id = 'strava_layer';
        this.stravaLayerInput.checked = plan.getStravaLayer();
        var stravaLayerText = L.DomUtil.create('span', '', stravaLayerContainer);
        stravaLayerText.htmlFor = 'strava_layer';
        stravaLayerText.innerHTML = L.localisation.get('settings.showStravaHeatmap');

        L.DomEvent.on(this.stravaLayerInput, 'change', L.bind(function(e) {
            control.getPlan().setStravaLayer(e.target.checked);
            map.removeLayer(layers.strava);
            if (e.target.checked) {
               // Strava only available at zoom level 16
               if (map.getZoom() > 16) {
                  map.setZoom(16);
               }
               layers.strava.addTo(map);
            }
            L.DomEvent.preventDefault(e);
        }, this));
	*/

        /* FKT layer */
        var fktLayerContainer = L.DomUtil.create('label', 'checkbox', container);
        this.fktLayerInput = L.DomUtil.create('input', 'filled-in', fktLayerContainer);
        this.fktLayerInput.type = 'checkbox';
        this.fktLayerInput.id = 'fkt_layer';
        this.fktLayerInput.checked = plan.getFKTLayer();
        var fktLayerText = L.DomUtil.create('span', '', fktLayerContainer);
        fktLayerText.htmlFor = 'fkt_layer';
        fktLayerText.innerHTML = L.localisation.get('settings.showFKTroutes');

        L.DomEvent.on(this.fktLayerInput, 'change', L.bind(function(e) {
            control.getPlan().setFKTLayer(e.target.checked);
            map.removeLayer(layers.fkt);
            if (e.target.checked) {
               layers.fkt.addTo(map);
            }
            L.DomEvent.preventDefault(e);
        }, this));

        var uiParagraph = L.DomUtil.create('p', '', container);
        uiParagraph.innerHTML = L.localisation.get('settings.uiPreferences');

        /* Imperial Units */
        var imperialUnitsContainer = L.DomUtil.create('label', 'checkbox', container);
        this.imperialUnitsInput = L.DomUtil.create('input', 'filled-in', imperialUnitsContainer);
        this.imperialUnitsInput.type = 'checkbox';
        this.imperialUnitsInput.id = 'imperial_units';
        this.imperialUnitsInput.checked = plan.getImperialUnits();
        var imperialUnitsText = L.DomUtil.create('span', '', imperialUnitsContainer);
        imperialUnitsText.htmlFor = 'imperial_units';
        imperialUnitsText.innerHTML = L.localisation.get('settings.imperial');

        L.DomEvent.on(this.imperialUnitsInput, 'change', L.bind(function(e) {
            L.DomEvent.preventDefault(e);
            control.getPlan().setImperialUnits(e.target.checked);
            control.getPlan().updateSettingsUI();
            carousel.refresh();
            locationHash.updateLocationHash();
        }, this));

        /* Draw straight lines */
        var straightLinesContainer = L.DomUtil.create('label', 'checkbox', container);
        this.straightLinesInput = L.DomUtil.create('input', 'filled-in', straightLinesContainer);
        this.straightLinesInput.type = 'checkbox';
        this.straightLinesInput.id = 'straight_lines';
        this.straightLinesInput.checked = plan.getStraightLines();
        var straightLinesText = L.DomUtil.create('span', '', straightLinesContainer);
        straightLinesText.htmlFor = 'straight_lines';
        straightLinesText.innerHTML = L.localisation.get('settings.drawStraightLines');

        L.DomEvent.on(this.straightLinesInput, 'change', L.bind(function(e) {
            control.getPlan().setStraightLines(e.target.checked);
            L.DomEvent.preventDefault(e);
        }, this));

        /* Prevent click edits */
        var preventClickEditsContainer = L.DomUtil.create('label', 'checkbox', container);
        this.preventClickEditsInput = L.DomUtil.create('input', 'filled-in', preventClickEditsContainer);
        this.preventClickEditsInput.type = 'checkbox';
        this.preventClickEditsInput.id = 'prevent_click_edits';
        this.preventClickEditsInput.checked = plan.getPreventClickEdits();
        var preventClickEditsText = L.DomUtil.create('span', '', preventClickEditsContainer);
        preventClickEditsText.htmlFor = 'prevent_click_edits';
        preventClickEditsText.innerHTML = L.localisation.get('settings.runMode');

        L.DomEvent.on(this.preventClickEditsInput, 'change', L.bind(function(e) {
            control.getPlan().setPreventClickEdits(e.target.checked);
            // disable undo button
            locationHash.options.undoEnabled = !e.target.checked;
            // disable dragging on all markers
            map.eachLayer(function (layer) {
               if (layer instanceof L.Marker && typeof layer.dragging !== 'undefined') {
                  if (e.target.checked) {
                     layer.dragging.disable();
                  } else {
                     layer.dragging.enable();
                  }
               }
            });
            // follow the gps
            lc.stop();
            if (e.target.checked) {
               lc.options.setView = 'always';
            } else {
               lc.options.setView = 'untilPanOrZoom';
            }
            lc.start();
            L.DomEvent.preventDefault(e);
        }, this));

        return L.DomUtil.create('div', 'leaflet-control-hidden');
    },
});
